require('./payrollLoanCompilationCard.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');
const { isEqual } = require('lodash/lang');
//@core
const { formatText } = require('core/i18n').i18n;
// @ components
const ContractLoanCompilationCard = require('../../contractLoanCompilationCard/contractLoanCompilationCard');
//@utilities
const { getFormattedString, formatCurrency, decimalsLength, formatAmount } = require('utilities/currencyHelper');
const { getLastNChars } = require('utilities/stringHelper');
// @constants
const { findPurposeById } = require('../../contractPayrollLoan/payrollLoanPurposes');
const { WIZARD_FIRST_STEP } = require('constants/index');

class PayrollLoanCompilationCard extends React.Component {

    buildAccount() {
        const { immAccount } = this.props;
        const accountAlias = immAccount.get('alias');
        const accountIban = getLastNChars(immAccount.get('iban'));
        const accountBalance = getFormattedString(immAccount.get('balance'));

        return [
            {
                label: formatText('payrollLoanCompilationCard-associatedAccount'),
                text: `${accountAlias} ${accountIban}`,
                className: 'payroll-loan-compilation-card__list-separator'
            },
            {
                label: formatText('payrollLoanCompilationCard-accountBalance'),
                text: `${accountBalance}`
            }
        ];
    }

    buildFooterList(nodata) {
        const { immAccount, callKOxDTI } = this.props;
        const openingCommission = this.buildOpeningCommission(nodata, callKOxDTI);
        let list = [
            openingCommission
        ];

        if (immAccount) {
            list = list.concat(this.buildAccount());
        }

        return list;
    }

    buildOpeningCommission(nodata, callKOxDTI) {
        const { immStep, isRequest } = this.props;
        const rawArrangementFee = immStep.get('arrangementFee');
        const rawCurrency = immStep.get('currency');
        const toDefine = formatText('contractLoanCompilationCard-nodata');
        const currency = formatCurrency(rawCurrency);
        const arrangementPercentage = immStep.get('arrangementPercentage');
        const decimalsArragementFee = decimalsLength(rawArrangementFee);
        const arrangementFee = formatAmount(rawArrangementFee, decimalsArragementFee);
        const enableDocumentsFlow = immStep.get('enableDocumentsFlow');
        const commissionSuperIndex =
            isRequest && immStep.get('visibleStep') === WIZARD_FIRST_STEP && !enableDocumentsFlow ? 2 : 1;

        return {
            label: formatText('payrollLoanCompilationCard-openingCommission', [arrangementPercentage]),
            additionalLabel: (<sup>{commissionSuperIndex}</sup>),
            text: nodata && isEqual(callKOxDTI, undefined) ? toDefine : `${arrangementFee} ${currency}`
        };
    }

    buildPurposeSection() {
        const { immStep, isDragoFeature } = this.props;

        if (!!immStep.get('selectedPurpose') || immStep.get('selectedPurposeDrago')) {
            let finalPurpose = findPurposeById(immStep.get('selectedPurpose'));
            let finalPurposeText = !!finalPurpose ? formatText(finalPurpose.text) : '';
            let finalPurposeIcon = !!finalPurpose ? finalPurpose.icon : '';

            if (isDragoFeature && !!immStep.get('newPurposesList')) {
                finalPurpose = immStep.get('newPurposesList').find(purposeElement => purposeElement.get('id') === immStep.get('selectedPurposeDrago'));
                finalPurposeText = !!finalPurpose ? finalPurpose.get('text') : finalPurpose;
                finalPurposeIcon = !!finalPurpose ? finalPurpose.get('icon') : null;
            }

            let content;
            const purposeIcon = classnames('icon', 'payroll-loan-compilation-card__icon', finalPurposeIcon);
            if (!!finalPurpose) {
                content = (
                    <div className="payroll-loan-compilation-card__purpose-section">
                        <i className={purposeIcon}></i>
                        {finalPurposeText}
                    </div>
                );
            }
            return content;
        }

    }

    buildTinTooltip() {
        const tooltipComp = (
            <div className={"contract-loan-compilation-card__tin-tooltip--body"}>
                {formatText("payrollLoanCompilationCard-tinTooltipText")}
            </div>
        );

        return {
            icon: 'icon-informacion',
            tooltipPlacement: 'top',
            tooltipClassName: 'contract-loan-compilation-card__tin-tooltip',
            iconCustomClass: 'contract-loan-compilation-card__tae-icon',
            tooltipOffset: [0, -10],
            information: tooltipComp
        };
    }

    render() {
        const { immStep, taeTooltip, showTinTooltip, nodataKOxDTI, callKOxDTI, isCollective, setCurrentProductCollective, isPayrrolLoan } = this.props;
        const nodata = isEqual(nodataKOxDTI, undefined) ? !immStep.get('initialized') : nodataKOxDTI;
        const selectedPurposeSection = this.buildPurposeSection();
        const footerList = this.buildFooterList(nodata);

        let tinTooltip = null;

        if (showTinTooltip && (immStep.get("userType") === 'TS')) {
            tinTooltip = this.buildTinTooltip();
        }

        return (
            <ContractLoanCompilationCard
                payrollLoanTooltip={tinTooltip}
                selectedPurposeSection={selectedPurposeSection}
                setCurrentProductCollective={setCurrentProductCollective}
                immSummary={immStep}
                taeTooltip={taeTooltip}
                footerList={footerList}
                nodata={nodata}
                callKOxDTI={callKOxDTI}
                isCollective={isCollective}
                isPayrrolLoan={isPayrrolLoan}
            />
        );
    }
}

PayrollLoanCompilationCard.propTypes = {
    callKOxDTI: PropTypes.bool,
    isRequest: PropTypes.bool,
    immAccount: PropTypes.object,
    immStep: PropTypes.object.isRequired,
    isCollective: PropTypes.bool,
    isDragoFeature: PropTypes.bool,
    nodataKOxDTI: PropTypes.bool,
    setCurrentProductCollective: PropTypes.func,
    showTinTooltip: PropTypes.bool,
    taeTooltip: PropTypes.object,
    isPayrrolLoan: PropTypes.bool,
};

PayrollLoanCompilationCard.defaultProps = {
    isRequest: false,
};

module.exports = PayrollLoanCompilationCard;
